module.exports = __webpack_public_path__ + "img/standard.39858d16.jpg";